module.exports = __webpack_public_path__ + "img/phone.9a2ce098.png";